module.exports = __webpack_public_path__ + "static/media/01.2aa12073.gif";